import { Component, OnInit, Input } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-smash-circular-progress',
  templateUrl: './smash-circular-progress.component.html',
  styleUrls: ['./smash-circular-progress.component.scss'],
  animations: [
    trigger(
      'fade', [
      transition(':leave', [
        style({ opacity: 1 }),
        animate('550ms', style({ opacity: 0 })),
      ])
    ]
    )
  ],
})
export class SmashCircularProgressComponent implements OnInit {

  @Input() loadingFinished = false;
  @Input() progress: number;

  radius = 54;
  circumference = 2 * Math.PI * this.radius;


  constructor() { }

  ngOnInit() { }

  get dashoffset() {
    let progress = this.progress / 100;
    if (this.loadingFinished) {
      progress = 1;
    }
    return this.circumference * (1 - progress);
  }

}
